import { createFileRoute } from '@tanstack/react-router'
import { Link } from '@spcc/core'
import { ArrowLeft, Button, Card, CardContent, CardHeader, CardTitle } from '@spcc/uikit'

export const Route = createFileRoute('/account-deletion')({
  component: AccountDeletionPage,
})

const ACCOUNT_DELETION_LAST_UPDATED = 'May 6, 2026'

function AccountDeletionPage() {
  return (
    <div className="safe-top relative min-h-screen overflow-hidden">
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-1/2 -left-1/2 h-full w-full rounded-full bg-gradient-to-br from-primary/30 via-transparent to-transparent blur-3xl" />
        <div className="absolute -bottom-1/2 -right-1/2 h-full w-full rounded-full bg-gradient-to-tl from-accent/20 via-transparent to-transparent blur-3xl" />
        <div className="absolute right-1/4 top-1/4 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
      </div>

      <div className="mx-auto w-full max-w-3xl px-4 py-10">
        <div className="mb-6">
          <Button asChild variant="ghost" className="glass">
            <Link to="/login">
              <ArrowLeft className="mr-2 h-4 w-4 rtl:ml-2 rtl:mr-0 rtl:rotate-180" />
              Back to Sign In
            </Link>
          </Button>
        </div>

        <Card className="glass-card border-white/10">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl">customer spcc - Account Deletion</CardTitle>
            <p className="text-sm text-muted-foreground">
              Last updated: {ACCOUNT_DELETION_LAST_UPDATED}
            </p>
          </CardHeader>
          <CardContent>
            <article lang="en" dir="ltr" className="space-y-6 text-sm leading-6 text-foreground">
              <section className="space-y-2">
                <h2 className="text-base font-semibold">How to request account deletion</h2>
                <p>
                  customer spcc allows users to request account deletion directly in the app.
                </p>
                <ol className="list-decimal space-y-1 ps-5">
                  <li>Sign in to your account in the customer spcc app.</li>
                  <li>Go to Settings.</li>
                  <li>Open the Profile tab.</li>
                  <li>Select Delete Account.</li>
                  <li>Confirm the deletion request in the confirmation dialog.</li>
                </ol>
              </section>

              <section className="space-y-2">
                <h2 className="text-base font-semibold">What data is deleted</h2>
                <ul className="list-disc space-y-1 ps-5">
                  <li>User profile details and account access credentials.</li>
                  <li>Linked tenant user access associated with the deleted user.</li>
                  <li>App session tokens and authentication artifacts.</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h2 className="text-base font-semibold">What data may be retained</h2>
                <p>
                  Certain records may be retained for legal, regulatory, security, and financial audit
                  requirements.
                </p>
                <ul className="list-disc space-y-1 ps-5">
                  <li>Order, delivery, invoice, and transaction records required for compliance and audits.</li>
                  <li>Security and system logs required for fraud prevention and incident investigations.</li>
                </ul>
              </section>

              <section className="space-y-2">
                <h2 className="text-base font-semibold">Retention period</h2>
                <ul className="list-disc space-y-1 ps-5">
                  <li>Account access is removed promptly after confirmation of deletion.</li>
                  <li>Compliance and audit records are retained only for the minimum period required by law.</li>
                </ul>
              </section>
            </article>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
